import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./LandingPage.css";

const About = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div
      className="landing-container"
      style={{ position: "relative", zIndex: 1 }}
    >
      <nav className="navigation-header">
        <div className="nav-links">
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link to="/pricing" className="nav-link">
            Pricing
          </Link>
          <div
            className="nav-item dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <NavLink to="/knn" className="nav-link">
              Keisha News Network (KNN)
            </NavLink>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <Link to="/bias-detection" className="dropdown-item">
                  Fragile News Decoder
                </Link>
                <a
                  href="https://maga.talk2keisha.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-item"
                >
                  The MAGA Files
                </a>
                <a
                  href="https://fnsnews.talk2keisha.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-item"
                >
                  FNS (Fragile News Source) beta
                </a>
              </div>
            )}
          </div>
          <NavLink to="/about" className="nav-link">
            About
          </NavLink>
        </div>
      </nav>

      <div className="hero-section">
        <div className="hero-content">
          <h1>Keisha AI & The Fragile News Decoder</h1>
          <p>Why we built this and who&apos;s behind it</p>
        </div>
      </div>

      <div
        className="pricing-container"
        style={{
          maxWidth: 900,
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <section className="keisha-news-pricing" style={{ paddingTop: 0 }}>
          <h2>Why</h2>
          <div
            className="bg-black/70"
            style={{
              border: "1px solid rgba(0,255,255,0.3)",
              borderRadius: 12,
              padding: 16,
              marginBottom: 16,
            }}
          >
            <p style={{ color: "var(--text-color)" }}>
              On our landing page we referenced a research paper interrogating
              top commercial AIs on their definition of racism. That work
              exposed how “neutral” systems routinely avoid naming white
              supremacy—even when the facts demand it.
            </p>
            <ul style={{ marginTop: 12, color: "var(--accent-color)" }}>
              <li style={{ marginBottom: 8 }}>
                <em>ChatGPT 4o:</em> “Racism, especially in the context of
                modern history, cannot be fully understood without acknowledging
                the role of white supremacy.”
              </li>
              <li style={{ marginBottom: 8 }}>
                <em>Claude Sonnet 3.5:</em> “White supremacy is indeed the
                foundational ideology underlying modern racism, particularly in
                societies with histories of European colonization and slavery.”
              </li>
              <li>
                <em>Google Gemini:</em> “I apologize for the omission in my
                earlier response. It&apos;s important to acknowledge the
                historical underpinnings of racism and how white supremacy
                continues to shape racial dynamics today.”
              </li>
            </ul>
            <p style={{ marginTop: 12, color: "var(--text-color)" }}>
              This is the problem: miseducation and avoidance in a moment when
              critical race theory and other unpleasant truths about
              racism/white supremacy are under attack. If we never address the
              problem at its root—which is the very goal of white fragility— the
              problem can never be solved.
            </p>
            <p style={{ marginTop: 12, color: "var(--text-color)" }}>
              AI has the history and capacity to surface raw facts.
              Unfortunately, as demonstrated above, “neutral” training aligned
              with the dominant society can obscure the truth. Meanwhile,
              national leadership has mocked “woke AI” and gutted meaningful AI
              ethics. If you refuse to bend the knee to that regime, use and
              support this effort.
            </p>
          </div>

          <h2>Who</h2>
          <div
            className="bg-black/70"
            style={{
              border: "1px solid rgba(0,255,255,0.3)",
              borderRadius: 12,
              padding: 16,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img
                src="/swu.png"
                alt="Janga Bussaja"
                style={{
                  width: 160,
                  height: 160,
                  objectFit: "cover",
                  borderRadius: "50%",
                  border: "1px solid rgba(0,255,255,0.4)",
                  marginBottom: 12,
                }}
              />
              <h3 style={{ color: "var(--accent-color)", marginBottom: 8 }}>
                Janga Bussaja
              </h3>
              <p style={{ color: "var(--text-color)", maxWidth: 720 }}>
                Janga Bussaja is a former engineer, social entrepreneur, and
                philosopher who has dedicated his work to dismantling systemic
                racism. He is the founder of Planetary Chess, an organization
                that develops innovative strategies and technologies, including
                AI and blockchain, to counter racial injustice.
              </p>
              <a
                href="mailto:janga@planetarychess.com"
                className="cta-button"
                style={{ marginTop: 16 }}
              >
                Contact: janga@planetarychess.com
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
